import { CometHead, CometTail, Container, SpinnerSvg, TrackRing } from './Loader.styled'

import type { JSX } from 'react'

const VIEWBOX_SIZE = 24
const CENTER = VIEWBOX_SIZE / 2
const RADIUS = 10
const STROKE_WIDTH = 2.5
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

// Comet proportions: a bright head arc with a faded tail trailing right behind it.
const HEAD_LENGTH = CIRCUMFERENCE * 0.25
const TAIL_LENGTH = CIRCUMFERENCE * 0.2

interface Props {
  size?: number
  color?: 'primary' | 'inherit'
  // Waits a moment before showing, for loads that are often quick (lists, folders).
  delayed?: boolean
}

export const Loader = (props: Props): JSX.Element => {
  const { size = 40, color = 'primary', delayed = false } = props

  return (
    <Container $delayed={delayed}>
      <SpinnerSvg
        $isPrimary={color === 'primary'}
        width={size}
        height={size}
        viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
        role="progressbar"
        aria-label="Chargement"
      >
        <TrackRing cx={CENTER} cy={CENTER} r={RADIUS} strokeWidth={STROKE_WIDTH} />
        <CometTail
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={`${TAIL_LENGTH} ${CIRCUMFERENCE - TAIL_LENGTH}`}
          strokeDashoffset={TAIL_LENGTH}
        />
        <CometHead
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={`${HEAD_LENGTH} ${CIRCUMFERENCE - HEAD_LENGTH}`}
        />
      </SpinnerSvg>
    </Container>
  )
}
